<template>
  <div style="margin-left: -4%">
    <div v-if="disable" class="name">{{ orgName }}</div>
    <div v-else>
      <el-select
        multiple
        :multiple-limit="1"
        v-model="orgCodes"
        :placeholder="`请选择${placeholder}`"
        style="width:400px;"
      >
        <el-option
          v-for="(item, index) in orgList"
          :key="index"
          :label="item.orgName"
          :value="item.orgCode"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  // 选择区域
  name: 'perfect-theme-org',
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    orgList: {
      type: Array,
      default: () => {
        return []
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  watch: {
    orgList (list) {
      // 仅有一个则默认选中
      if (list.length === 1) {
        this.orgCodes.push(list[0].orgCode)
      }
    },
    orgCodes: {
      deep: true,
      handler (newVal, oldVal) {
        if (this.$route.query.handleType === 'config') {
          this.$parent.getRegionListByBu(this.orgCodes[0])
          this.$parent.setOrgCode(this.orgCodes[0])
        }
        // console.log('orgCodes change newVal', newVal)
      }
    }
  },
  data () {
    return {
      orgCodes: [],
      orgName: '',
      pageType: '',
      checkedResult: true
    }
  },
  created () {
    this.pageType = this.$route.query.handleType
  },
  methods: {
    setData () {
      if (this.pageType === 'update') {
        this.orgName = this.info.orgName
      }
    },
    checkData () {
      this.checkedResult = true
      if (this.pageType === 'config' && this.orgCodes.length === 0) {
        this.checkedResult = false
      }
    }
    // handleOrgChange (codes) {
    //   // console.log('val', codes)
    //   this.$parent.getRegionListByBu(codes[0])
    // }
  }
}
</script>

<style lang="scss" scoped>
.name {
  line-height: 40px;
  color: #333;
}
</style>
